import { useAdminStats, useAdminSupport } from "../../hooks/use-admin.js";
import { Skeleton } from "../../components/skeleton.js";

export function AdminStatsPage() {
  const { data, isLoading } = useAdminStats();
  const { data: supportData } = useAdminSupport();

  return (
    <div className="product-page">
      <h1 className="page-title">Stats</h1>
      {isLoading && <Skeleton lines={4} />}
      {data && (
        <>
          <section className="product-section">
            <h2 className="section-title">Overview</h2>
            <div className="stat-grid">
              <div className="stat-item">
                <span className="stat-item__value">{data.totalUsers}</span>
                <span className="stat-item__label">Total users</span>
              </div>
              <div className="stat-item">
                <span className="stat-item__value">{data.totalOrgs}</span>
                <span className="stat-item__label">Organisations</span>
              </div>
              <div className="stat-item">
                <span className="stat-item__value">{data.totalWebsites}</span>
                <span className="stat-item__label">Websites</span>
              </div>
              <div className="stat-item">
                <span className="stat-item__value">
                  €{(data.mrrEurCents / 100).toFixed(0)}
                </span>
                <span className="stat-item__label">MRR</span>
              </div>
            </div>
          </section>

          <section className="product-section">
            <h2 className="section-title">Subscriptions</h2>
            <div className="stat-grid">
              <div className="stat-item">
                <span className="stat-item__value text-success">
                  {data.activeSubscriptions}
                </span>
                <span className="stat-item__label">Active</span>
              </div>
              <div className="stat-item">
                <span className="stat-item__value text-warning">
                  {data.trialingSubscriptions}
                </span>
                <span className="stat-item__label">Trialing</span>
              </div>
              <div className="stat-item">
                <span className="stat-item__value text-danger">
                  {data.pastDueSubscriptions}
                </span>
                <span className="stat-item__label">Past due</span>
              </div>
              <div className="stat-item">
                <span className="stat-item__value text-muted">
                  {data.canceledSubscriptions}
                </span>
                <span className="stat-item__label">Canceled</span>
              </div>
              <div className="stat-item">
                <span className="stat-item__value text-danger">
                  {data.incompleteSubscriptions}
                </span>
                <span className="stat-item__label">Incomplete</span>
              </div>
            </div>
          </section>

          <section className="product-section">
            <h2 className="section-title">Trial conversion</h2>
            <div className="stat-grid">
              <div className="stat-item">
                <span className="stat-item__value">
                  {data.trialConversionRate}%
                </span>
                <span className="stat-item__label">Conversion rate</span>
              </div>
              <div className="stat-item">
                <span className="stat-item__value">
                  {data.trialConverted} / {data.trialTotal}
                </span>
                <span className="stat-item__label">Trials converted</span>
              </div>
            </div>
          </section>

          <section className="product-section">
            <h2 className="section-title">Revenue by plan</h2>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Plan</th>
                  <th className="text-right">Subscribers</th>
                  <th className="text-right">MRR</th>
                  <th className="text-right">% of Total</th>
                </tr>
              </thead>
              <tbody>
                {data.revenueByPlan.map((r) => (
                  <tr key={r.planId}>
                    <td>{r.planName}</td>
                    <td className="text-right">
                      {r.subscriberCount}
                    </td>
                    <td className="text-right">
                      €{(r.mrrEurCents / 100).toFixed(0)}
                    </td>
                    <td className="text-right">
                      {data.mrrEurCents > 0
                        ? `${Math.round((r.mrrEurCents / data.mrrEurCents) * 100)}%`
                        : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>

          <section className="product-section">
            <h2 className="section-title">Recent activity</h2>
            {supportData?.alerts && supportData.alerts.length > 0 ? (
              <ul className="compact-list">
                {supportData.alerts.slice(0, 5).map((alert, i) => (
                  <li key={i} className="compact-list__item">
                    <span
                      className={`status-dot status-dot--${alert.severity}`}
                      aria-label={alert.severity}
                    />
                    <span className="compact-list__url text-muted">
                      {alert.websiteUrl}
                    </span>
                    <span className="compact-list__msg">{alert.message}</span>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-muted">No recent support alerts.</p>
            )}
          </section>
        </>
      )}
    </div>
  );
}
